const FILTER_KEYS = ['service', 'status', 'customer', 'seller', 'owner', 'area'];

export const createDefaultSalesMultiCustomerToolbarFilters = () => ({
  search: '',
  date_start: '',
  date_end: '',
  service: [],
  status: [],
  customer: [],
  seller: [],
  owner: [],
  area: [],
});

export const normalizeSalesMultiCustomerToolbarFilters = (filters) => {
  const normalized = filters && typeof filters === 'object' ? filters : {};

  const next = {
    ...createDefaultSalesMultiCustomerToolbarFilters(),
    ...normalized,
  };

  FILTER_KEYS.forEach((key) => {
    next[key] = Array.isArray(next[key]) ? next[key] : [];
  });

  next.search = String(next.search || '').trim();
  next.date_start = String(next.date_start || '').trim();
  next.date_end = String(next.date_end || '').trim();

  return next;
};

export const buildSalesMultiCustomerListParams = ({ toolbarFilters, toolbarSearch }) => {
  const filters = normalizeSalesMultiCustomerToolbarFilters(toolbarFilters);

  return {
    search: String(filters.search || toolbarSearch || '').trim(),
    date_start: filters.date_start,
    date_end: filters.date_end,
    service: filters.service,
    status: filters.status,
    customer: filters.customer,
    seller: filters.seller,
    owner: filters.owner,
    area: filters.area,
  };
};
